import React, { Component } from 'react';
import _ from 'lodash';

type PROPS = {
  className?: string,
  context: any,
  title: any,
  htmlTag: string,
  additionalProps?: any
  tooltipRef?: string
  closeOnClick?: boolean
};

class WithTooltip extends Component<PROPS, {}> {
  handleMouseOver = (event: any) => {
    const { context }: any = this.props;
    const tp = context[this.props.tooltipRef] || context.tooltip;
    tp && tp.handleMouseOver(event);
  };

  handleMouseOut = (event: any) => {
    const { context }: any = this.props;
    const tp = context[this.props.tooltipRef] || context.tooltip;
    tp && tp.handleMouseOut(event);

    clearTimeout(tp.openTimeout);
  };

  /**
   * Helper function which hides tooltip when focus is lost from element
   * @param event
   * coordinates X and Y are necessary in order to tell handleMouseOut method that we are out of the element
   */
  tooltipOnBlurHide = (event: any) => {
    const { context }: any = this.props;
    event.clientX = 0;
    event.clientY = 0;
    const tp = context[this.props.tooltipRef] || context.tooltip;
    tp && tp.handleMouseOut(event);
    clearTimeout(tp.openTimeout);
  }

  /**
   * Close toolTip on click
   * @param {MouseEvent} event
   */
  handleOnClick = (event: MouseEvent) => {
    if (this.props.closeOnClick) {
      this.handleMouseOut(event);
    }
  }

  render() {
    const { children, className, title, htmlTag, additionalProps } = this.props;
    let elProps = {
      className,
      title,
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut,
      onFocus: this.handleMouseOver,
      onBlur: this.tooltipOnBlurHide,
      onClick: this.handleOnClick
    };
    if (_.isObject(additionalProps)) {
      elProps = {
        ...elProps,
        ...additionalProps
      };
    }

    return React.createElement(
      htmlTag,
      elProps,
      children
    );
  }
}

export default WithTooltip;
